import {
  OptionsViewModel,
  StatesViewModel,
  Owner,
  AddressViewModel,
  blankOptionsVM,
  blankAddressVM
} from '@models/common.models';

export interface PurchaseRequestViewModel {
  id: number;
  owner?: OptionsViewModel;
  swoId: number;
  status: OptionsViewModel;
  purchaseType: OptionsViewModel;
  comment: string;
  cause: string;
  diagnosis: string;
  repairNeeded: string;
  action: string;
  parentCvi: number;
  cvi: OptionsViewModel;
  purchaseRequestInfo: PurchaseRequestInfoViewModel;
  canReopen: boolean;
  isHvac: boolean;
}

export interface PurchaseRequestSimpleViewModel {
  id: number;
  cvi: OptionsViewModel;
  createdBy: OptionsViewModel;
  createdDate: Date;
  status: OptionsViewModel;
}

export interface PurchaseRequestInfoViewModel {
  id: number;
  brand: OptionsViewModel;
  color: OptionsViewModel;
  otherColor: string;
  comment: string;
  delivery: number;
  description: string;
  disposalFee: number;
  estDelivery: Date;
  estTax: number;
  facility: OptionsViewModel;
  installation: number;
  itemNumber: string;
  modelNumber: string;
  partCost: number;
  restockingFee: number;
  state: StatesViewModel;
  supplier: OptionsViewModel;
  supplierUrl: string;
  total: number;
  calculatedCIL: number;
  cilTotal: number;
  cilOfferOnly: boolean;
  cilOfferReason: OptionsViewModel;
  cilEmail: string;
  fuel: OptionsViewModel;
  hvacParts: PurchaseRequestHvacViewModel[];
  parts: PurchaseRequestPartsViewModel[];
  replacementCost: number;
  savings: number;
  deliveryAddress?: AddressViewModel;
  vendorTechContactName: string;
  vendorTechContactPhone: string;
}

export enum CollectionTypes {
  None = 0,
  Delivered = 1,
  Pickup
}

export interface PurchaseRequestHvacViewModel {
  id: number;
  item: string;
  supplier?: OptionsViewModel;
  systemType?: OptionsViewModel;
  partModel?: OptionsViewModel;
  modelDescription: string;
  quantity: number;
  collectionType: CollectionTypes | string;
  deliveryAddress?: AddressViewModel;
  vendorTechContactName: string;
  vendorTechContactPhone: string;
  pickupLocation?: OptionsViewModel;
  partCost: number;
  estTax: number;
  restockFee: number;
  deliveryFee: number;
  installationFee: number;
  disposalFee: number;
  total: number;
  fromAutho: boolean;
  quantityPartCost: number;
}

export var blankPurchaseRequestHvacVM = {
  id: 0,
  item: '',
  supplier: blankOptionsVM,
  systemType: blankOptionsVM,
  partModel: blankOptionsVM,
  modelDescription: '',
  quantity: 1,
  collectionType: CollectionTypes.None,
  deliveryAddress: blankAddressVM,
  vendorTechContactName: '',
  vendorTechContactPhone: '',
  pickupLocation: blankOptionsVM,
  partCost: 0.0,
  estTax: 0.0,
  restockFee: 0.0,
  deliveryFee: 0.0,
  installationFee: 75.0,
  disposalFee: 50.0,
  total: 0.0,
  fromAutho: false,
  quantityPartCost: 0.0
} as PurchaseRequestHvacViewModel;

export interface PurchaseRequestSearchViewModel {
  id: number;
  swoId: number;
  contractId: number;
  contractNumber: string;
  owner: Owner;
  requestType: string;
  dateOpened: Date;
  vendorId: string;
  cilOffered: string;
  openDays: string;
  cVIItem: string;
  city: string;
  state: string;
}

export interface PurchasingRequestStatusesViewModel {
  readonly total: number;
  readonly applOptions: number;
  readonly applPurchase: number;
  readonly applRushPch: number;
  readonly hvacOptions: number;
  readonly hvacPurchase: number;
  readonly hvacRushPch: number;
  readonly miscellaneous: number;
  readonly partsSearch: number;
  readonly unknownRequestType: number;
}

export enum PurchaseRequestStatus {
  Open = 0,
  Closed = 10
}

export interface Accessory {
  readonly serviceCode: string;
  readonly serviceCodeDescription: string;
  readonly serviceCodeType: string;
  readonly supplierPrice: number;
}

// NOTE: THIS IS ONLY USED TO CORRECT THE 'ACCESSSORY MISSPELLING COMING FROM THE DB
export enum AccessoryCodeType {
  Accesssory = 'Accessory',
  Delivery = 'Delivery',
  Installation = 'Installation'
}

export enum PurchaseType {
  ApplOptions = 1,
  ApplPurchase,
  ApplRushPch,
  HVACOptions,
  HVACPurchase,
  HVACRushPch,
  Miscellaneous,
  PartsSearch
}

export interface PurchaseRequestPartsViewModel {
  id: number;
  item: string;
  supplier?: OptionsViewModel;
  brand?: OptionsViewModel;
  status?: OptionsViewModel;
  modelNumber: string;
  partNumber: string;
  quantity: number;
  partCost: number;
  quantityPartCost: number;
  estTax: number;
  restockFee: number;
  deliveryFee: number;
  installationFee: number;
  total: number;
  fromAutho: boolean;
}

export var blankPurchaseRequestPartsVM = {
  id: 0,
  item: '',
  supplier: blankOptionsVM,
  brand: blankOptionsVM,
  status: {
    id: -5
  } as OptionsViewModel,
  modelNumber: '',
  partNumber: '',
  quantity: 1,
  partCost: 0.0,
  estTax: 0.0,
  restockFee: 0.0,
  deliveryFee: 0.0,
  installationFee: 0.0,
  total: 0.0,
  fromAutho: false,
  quantityPartCost: 0.0
} as PurchaseRequestPartsViewModel;

export interface PartsItemAmounts {
  quantity: number;
  partCost: number;
  estTax: number;
  restockFee: number;
  deliveryFee: number;
  installationFee: number;
  total: number;
  quantityPartCost: number;
}

export interface PurchaseRequestPartsTotals {
  partCostTotal: number;
  estTaxTotal: number;
  restockFeeTotal: number;
  deliveryFeeTotal: number;
  installationFeeTotal: number;
  partsTotal: number;
  savings: number;
}



// WEBPACK FOOTER //
// ./src/_models/PurchaseRequest.ts